import React, { ReactElement, useEffect } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import LegislativnyMaterialList
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialList';
import routes from '../../../routing/routes';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import useFilterFromUrl
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialList/hooks/useFilterFromUrl';
import externalRoutes from '../../../routing/externalRoutes';
import SuccessMessages from '../../../module/SuccessMessages';
import RssLink from '../../../module/PageHeadingWithBackButton/RssLink';

const LegislativnyMaterialListPage = (): ReactElement => {
  const { initialFilter, initialFilterLoading } = useFilterFromUrl();

  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-meta',
      title: 'Legislatívne procesy',
      description: 'Prehľad legislatívnych procesov na portáli Slov-Lex - sledovanie prípravy, '
          + 'pripomienkovania a priebehu tvorby právnych predpisov Slovenskej republiky.',
    }, '*');
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.list,
          heading: 'Legislatívne procesy',
        },
      ]}
      />
      <GlobalErrors />
      <SuccessMessages />
      <PageHeadingWithBackButton
        heading="Legislatívne procesy"
        elementNextToHeading={(
          <RssLink to={externalRoutes.rss.legislativnyMaterial.list} />
            )}
      />
      <Loader loading={initialFilterLoading}>
        {initialFilter && !initialFilterLoading && (
          <LegislativnyMaterialList initialFilter={initialFilter} />
        )}
      </Loader>
    </Layout>
  );
};

export default LegislativnyMaterialListPage;
